/*
 * Scenario: rewrite-with-code
 *
 * Wie rewrite-with-formats, aber der Vorschlag enthaelt einen Inline-Code-Span
 * (`code`). Browser-Test-Anker fuer F1: Code-Span landet als type='code' im
 * RT-Modell, soll im Editor als Mono + Sondercolor (Style.EDITOR_CODE)
 * gerendert werden, im Composite-Renderer (Review-Overlay) als Mono-Glyph
 * mit Diff-Akzent-Color (Diff-Color dominiert).
 *
 * Erwartung im Browser:
 *   - Composite-Line zeigt das Wort `console.log` mit Mono-Font
 *   - Toggle T schaltet zwischen Original (Plain) und Vorschlag (Mono)
 *   - Apply: Editor zeigt das Wort weiterhin als Mono + EDITOR_CODE-Color
 */

import { emit, wait, resolve, payloadFromMarkdown } from './_helpers.js'

export const name = 'rewrite-with-code'
export const description = 'Rewrite with an inline-code span (mono + diff-color in review).'

export async function run(state) {
    const toolCallId = 'tu_rwc_' + Date.now().toString(36)

    await emit(state, 'session', { sessionId: 'mock-rewrite-with-code' }, 0)
    await emit(state, 'thinking', { text: 'Adding the command name as inline code…' }, 300)
    await emit(state, 'thinkingDone', {}, 200)
    await emit(state, 'toolCall', { toolCallId: 'tu_read_1', tool: 'read_section', input: {} }, 150)
    await emit(state, 'toolResult', { toolCallId: 'tu_read_1', tool: 'read_section', summary: 'section read' }, 200)

    const paragraphId = resolve(state, '$cursor.paragraphId')
    const originalText = resolve(state, '$cursor.text')
    const baseVersion = resolve(state, '$cursor.version')

    // Inline-Code in einem normalen Satz — kein Heading, kein Bold drumrum.
    // Wer Bold + Code testen will, nimmt rewrite-with-formats als Vorlage.
    const markdown = 'Run `console.log` to inspect the value.'

    const patch = payloadFromMarkdown(markdown, 'text')

    await emit(state, 'proposeRewrite', {
        toolCallId,
        paragraphId,
        baseVersion: typeof baseVersion === 'number' ? baseVersion : undefined,
        originalText: typeof originalText === 'string' ? originalText : '(paragraph text here)',
        newText: patch.text,
        newFormats: patch.formats,
        newLinks: patch.links,
        newHeadingLevel: patch.headingLevel,
        newListType: patch.listType,
        newListLevel: patch.listLevel,
        newBlockquote: patch.blockquote,
        reason: 'Inline-code makes the command name unambiguous.'
    }, 400)
    await emit(state, 'done', { usage: {} }, 200)

    try {
        const info = await wait(state, toolCallId, 5 * 60 * 1000)
        const reaction = info.result === 'applied'
            ? 'Code formatting is in. Want me to scan the rest for command names?'
            : info.result === 'version_mismatch'
                ? 'Paragraph was changed in the meantime — I will re-read and try again.'
                : 'Okay, I left the original text. Anything else to try?'
        await emit(state, 'delta', { text: reaction }, 300)
        await emit(state, 'done', { usage: {} }, 100)
    } catch { /* abort */ }
}
